var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.list),function(item,index){return [_c('span',{on:{"click":function($event){_vm.handleClick(index)}}},[_c('em',{style:({'background': item})})]),_vm._v(" "),((index + 1) % 12 === 0 && index !== 0 && (index + 1) !== _vm.list.length)?_c('br'):_vm._e()]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/color-picker/recommend-colors.vue